import React, { useState, useEffect } from "react";
import "./LoginSignup.css";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
import axios from "axios";
//loader
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import * as Constants from "../../constants/Constants";
import * as utils from "../../global/utils";
import * as AppUrls from "../../constants/AppUrls";
import * as Helpers from "../../global/Helpers";
import i18next from "i18next";
import SpinnersLoadingSIP from "../SpinnersLoadingSIP/SpinnersLoadingSIP";
import checkMarkCorrect from "../../assets/icons/ic-check-mark-correct.png";
import checkMarkFalse from "../../assets/icons/ic-check-mark-x.png";
import { format } from "react-string-format";
import { otpSessionId } from "./Login.js";

toast.configure();

function ChangePassword() {
  const { t } = useTranslation();
  const [username, setUsername] = useState("");
  // const [oldPassword, setOldPassword] = useState("");
  const [oldPassword, setoldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPassword2, setConfirmPassword2] = useState("");
  const [redirect, setRedirect] = useState(null);
  const [visible, setVisible] = useState(false);
  const [NewPasswordType, setNewPasswordType] = useState("password");
  const [ConfirmPasswordType, setConfirmPasswordType] = useState("password");
  // const errorNotify = (message) => {
  //     toast.error(message, {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         hideProgressBar: true,
  //         autoClose: Constants.errorNotifyDuration
  //     });
  // };
  const [MINLENGTH, set_MINLENGTH] = useState("");
  const [ENFORCE_START_WITH_ALPHA, set_ENFORCE_START_WITH_ALPHA] = useState("");
  const [ENFORCE_SPECIAL_CHAR, set_ENFORCE_SPECIAL_CHAR] = useState("");
  const [NUM_SMALL_CHAR, set_NUM_SMALL_CHAR] = useState("");
  const [NUM_SPECIAL_CHAR, set_NUM_SPECIAL_CHAR] = useState("");
  const [NUM_CAPITAL_CHAR, set_NUM_CAPITAL_CHAR] = useState("");
  const [IC_MINLENGTH, set_IC_MINLENGTH] = useState(checkMarkFalse);
  const [IC_ENFORCE_START_WITH_ALPHA, set_IC_ENFORCE_START_WITH_ALPHA] = useState(checkMarkFalse);
  const [IC_ENFORCE_SPECIAL_CHAR, set_IC_ENFORCE_SPECIAL_CHAR] = useState(checkMarkFalse);
  const [IC_NUM_SMALL_CHAR, set_IC_NUM_SMALL_CHAR] = useState(checkMarkFalse);
  const [IC_NUM_CAPITAL_CHAR, set_IC_NUM_CAPITAL_CHAR] = useState(checkMarkFalse);
  const [IC_NUM_SPECIAL_CHAR, set_IC_NUM_SPECIAL_CHAR] = useState(checkMarkFalse);

  function validate() {
    // if (!username) {
    //     errorNotify("Please enter username and try again.");
    //     return false;
    // }

    // if (!oldPassword) {
    //     errorNotify("Please enter old password and try again.");
    //     return false
    // }

    // if (!oldPassword) {
    //     errorNotify("Please enter old password and try again.");
    //     return false
    // }
    if (!password) {
      Helpers.errorNotify(t("Please_enter_password_and_try_again."), i18next.language);
      return false;
    }

    if (!confirmPassword) {
      Helpers.errorNotify(t("Please_enter_confirm_password_and_try_again."), i18next.language);
      return false;
    }

    if (password !== confirmPassword) {
      Helpers.errorNotify(t("passwordnotmatchconfirmedpassword"), i18next.language);
      return false;
    }

    if (password2 !== confirmPassword2 && localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT") {
      Helpers.errorNotify(t("passwordnotmatchconfirmedpassword2"), i18next.language);
      return false;
    }
    if ((password2 === "" || confirmPassword2 === "") && localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT") {
      Helpers.errorNotify(t("passwordandconfirmedpasswordarerequired2"), i18next.language);
      return false;
    }

    if (password2 !== "" && password2.length < 4 && localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT") {
      Helpers.errorNotify(t("Secondpasswordtooshort") + " 4 ", i18next.language);
      return false;
    }

    if (MINLENGTH !== "" && IC_MINLENGTH === checkMarkFalse) {
      Helpers.errorNotify(t("passwordtooshort") + " " + MINLENGTH, i18next.language );
      return false;
    }

    if (ENFORCE_START_WITH_ALPHA !== "" && IC_ENFORCE_START_WITH_ALPHA === checkMarkFalse) {
      Helpers.errorNotify(t("passwordcantstartno"), i18next.language);
      return false;
    }

    if (NUM_SPECIAL_CHAR !== "" && NUM_SPECIAL_CHAR !== "0" && IC_NUM_SPECIAL_CHAR === checkMarkFalse && ENFORCE_SPECIAL_CHAR === "Y") {
      Helpers.errorNotify(format(t("passwordcountspecialchar_X0"), NUM_SPECIAL_CHAR), i18next.language);
      return false;
    }

    if (ENFORCE_SPECIAL_CHAR !== "" && ENFORCE_SPECIAL_CHAR === "Y" && IC_ENFORCE_SPECIAL_CHAR === checkMarkFalse) {
      localStorage.getItem(Constants.localStorageConstants.company_name) === "ALRAMZ" ? Helpers.errorNotify(t("passwordEnforceSpecialCharALRAMZ"), i18next.language) : Helpers.errorNotify(t("passwordEnforceSpecialChar"), i18next.language);
      return false;
    }
    if (NUM_SMALL_CHAR !== "" && NUM_SMALL_CHAR !== "0" && IC_NUM_SMALL_CHAR === checkMarkFalse) {
      Helpers.errorNotify(format(t("passwordcountsmallchar_X0"), NUM_SMALL_CHAR), i18next.language);
      return false;
    }

    if (NUM_CAPITAL_CHAR !== "" && NUM_CAPITAL_CHAR !== "0" && IC_NUM_CAPITAL_CHAR === checkMarkFalse) {
      Helpers.errorNotify(format(t("passwordcountcapitalchar_X0"), NUM_CAPITAL_CHAR), i18next.language);
      return false;
    }
    return true;
  }

  useEffect(() => {
    getPasswordPolicy();
  }, []);

  function submit(e) {
    e.preventDefault();
    if (!validate()) {
      return;
    }
    callChangePasswordApi();
  }

  const callChangePasswordApi = async () => {
    setVisible(true);
    const params = {
      UserName: localStorage.getItem("username"), //username,
      Password: utils.encryptedString(password),
      Password2: utils.encryptedString(password2),
      MobileType: "",
      SessionID: "",
      UserIPAddress: localStorage.getItem("ipAddress"),
      TokenID: "",
      HdnKey: "",
      FingerPrintID: "",
      FingerPrintLevel: "",
      RegistrationId: "",
      isAuthorizeOnly: "N",
      // OldPassword:  localStorage.getItem("passwordToOTp"),
      OldPassword:  otpSessionId ? otpSessionId.value : "",
      WebCode: localStorage.getItem("WebCode"),
    };
    let url = Constants.baseURL + Constants.changesPassword;
    // let changesPasswordResponse = utils.changesPassword(params);
    // changesPasswordResponse
    let options = { withCredentials: true };

    await axios
      .post(url, params, options)
      .then((response) => {
        setVisible(false);
        //  console.log(response);

        var status = response.data["Status"];
        if (status === "0") {
          // toast.success("Password changed Successfully.", {
          //     position: toast.POSITION.BOTTOM_CENTER,
          //     hideProgressBar: true,
          //     autoClose: 1000
          // });
          Helpers.successNotify("passwordchangeed", i18next.language);

          let user = JSON.stringify(response.data);
          let webcode = response.data["WebCode"];
          //localStorage.setItem("user", user);
          localStorage.setItem("username", response.data["UserName"]);
          localStorage.setItem("WebCode", webcode);
          localStorage.setItem("isTermsAndConditions", response.data["isTermsAndConditions"]);
          localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);

          //window["connectionInitialize"](username, webcode);

          // if (response.data["isTermsAndConditions"] === "N" &&
          //     ((localStorage.getItem(Constants.localStorageConstants.EnableIPOQuickSell).toUpperCase() === "TRUE" && localStorage.getItem("IsNormalLogin") === "false") || localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase() === "IFS")) {
          //     setRedirect(AppUrls.TermsAndConditions);
          // }
          // else {
          setRedirect(AppUrls.trading);
          // }
        } else if (status === null) {
          setRedirect(AppUrls.login);
          // localStorage.getItem(Constants.localStorageConstants.company_name) === "CIBC" ? setRedirect(AppUrls.loginCIBC) :  setRedirect(AppUrls.login);
        } else {
          // Helpers.errorNotify(response.data[t("ErrorMsg"),i18next.language])
          Helpers.errorNotify(response.data["ErrorMsg"], i18next.language);
        }
      })
      .catch((error) => {
        setVisible(false);
        console.log(error);
        Helpers.errorNotify(error.message, i18next.language);
      });
  };

  const callLogOff = () => {
    //
    // props.setIsLoaderVisible(true);
    //console.log("logging out...");
    let logOffResponse = utils.logOff();
    logOffResponse
      .then((response) => {
        // props.setIsLoaderVisible(false);
        //console.log("Logged Off", response)
        if (response.status === 200) {
          localStorage.removeItem("user");
          localStorage.removeItem("ExpiredDocument");
          let UserName = localStorage.getItem("username");
          let RememberMe = localStorage.getItem("isRememberMe");
          let language = localStorage.getItem("language");

          let Comapnyname = localStorage.getItem(Constants.localStorageConstants.company_name);
          var prev = Helpers.getPreviousConfig();
          if (RememberMe === "true") {
            localStorage.clear();
            localStorage.setItem("isRememberMe", true);
            localStorage.setItem("username", UserName);
            localStorage.setItem("language", language);

            localStorage.setItem(Constants.localStorageConstants.company_name, Comapnyname);
          } else {
            localStorage.clear();
            localStorage.setItem("language", language);

            localStorage.setItem(Constants.localStorageConstants.company_name, Comapnyname);
          }
          Helpers.SetpreviosConfig(prev);
          setRedirect(AppUrls.login);
          //   setState({ redirect: AppUrls.login }, () => {
          //     disconnectSignalr();
          //   });
        }
      })
      .catch((error) => {
        //props.setIsLoaderVisible(false);
        //console.log("error", error);
      });
  };

  const getPasswordPolicy = () => {
    let getPasswordPolicyResponse = utils.getPasswordPolicy();
    getPasswordPolicyResponse
      .then((response) => response.data)
      .then((data) => {
        //   console.log("getPasswordPolicyResponse: ", data)
        //
        ;
        set_MINLENGTH(data["MINLENGTH"]);
        set_ENFORCE_START_WITH_ALPHA(data["ENFORCE_START_WITH_ALPHA"]);
        set_ENFORCE_SPECIAL_CHAR(data["ENFORCE_SPECIAL_CHAR"]);
        set_NUM_SMALL_CHAR(data["NUM_SMALL_CHAR"]);
        set_NUM_CAPITAL_CHAR(data["NUM_CAPITAL_CHAR"]);
        set_NUM_SPECIAL_CHAR(data["NUM_SPECIAL_CHAR"]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function onChangeNewPassword(e) {
    ;
    var Newpassword = e.target.value;
    setPassword(e.target.value);
    if (Newpassword.length >= parseInt(MINLENGTH) && IC_MINLENGTH === checkMarkFalse) {
      set_IC_MINLENGTH(checkMarkCorrect);
    }

    if (Newpassword.length < parseInt(MINLENGTH) && IC_MINLENGTH === checkMarkCorrect) {
      set_IC_MINLENGTH(checkMarkFalse);
    }

    if (Newpassword.length > 0) {
      if (Newpassword.charAt(0) <= "9" && Newpassword.charAt(0) >= "0") set_IC_ENFORCE_START_WITH_ALPHA(checkMarkFalse);
      else set_IC_ENFORCE_START_WITH_ALPHA(checkMarkCorrect);

      let specialFormat = localStorage.getItem(Constants.localStorageConstants.company_name) === "ALRAMZ" ? /[!$@%#]/ : /[~!@#$*]/;
      let containsSpecialChar = false;
      if (specialFormat.test(Newpassword)) {
        containsSpecialChar = true;
      }

      if (localStorage.getItem(Constants.localStorageConstants.company_name) === "ALRAMZ") {
        const specialChars = /[`*^&()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        if (specialChars.test(Newpassword)) {
          containsSpecialChar = false;
        } else {
          containsSpecialChar = true;
        }
      }

      let numberFormat = /\d/;
      let containsNumberChar = false;
      if (numberFormat.test(Newpassword)) {
        containsNumberChar = true;
      }

      let stringFormat = /[a-zA-Z]/;
      let containsletterChar = false;
      if (stringFormat.test(Newpassword)) {
        containsletterChar = true;
      }

      if (containsSpecialChar && containsNumberChar && containsletterChar) set_IC_ENFORCE_SPECIAL_CHAR(checkMarkCorrect);
      else set_IC_ENFORCE_SPECIAL_CHAR(checkMarkFalse);

      //checks small letter count
      if (parseInt(NUM_SMALL_CHAR) > 0) {
        let smallLetter = /[a-z]/;
        let smallLetterCount = 0;
        for (let position = 0; position < Newpassword.length; position++) {
          if (smallLetter.test(Newpassword.charAt(position))) {
            smallLetterCount += 1;
          }
        }
        if (parseInt(NUM_SMALL_CHAR) > smallLetterCount) set_IC_NUM_SMALL_CHAR(checkMarkFalse);
        else set_IC_NUM_SMALL_CHAR(checkMarkCorrect);
      }
      //checks capital letter count
      if (parseInt(NUM_CAPITAL_CHAR) > 0) {
        let capitalLetter = /[A-Z]/;
        let capitalLetterCount = 0;
        for (let position = 0; position < Newpassword.length; position++) {
          if (capitalLetter.test(Newpassword.charAt(position))) {
            capitalLetterCount += 1;
          }
        }
        if (parseInt(NUM_CAPITAL_CHAR) > capitalLetterCount) set_IC_NUM_CAPITAL_CHAR(checkMarkFalse);
        else set_IC_NUM_CAPITAL_CHAR(checkMarkCorrect);
      }

      //checks special letter count
      if (parseInt(NUM_SPECIAL_CHAR) > 0) {
        let specialLetterCount = 0;
        for (let position = 0; position < Newpassword.length; position++) {
          if (specialFormat.test(Newpassword.charAt(position))) {
            specialLetterCount += 1;
          }
        }
        if (parseInt(NUM_SPECIAL_CHAR) > specialLetterCount) set_IC_NUM_SPECIAL_CHAR(checkMarkFalse);
        else set_IC_NUM_SPECIAL_CHAR(checkMarkCorrect);
      }
    } else {
      if (IC_ENFORCE_START_WITH_ALPHA === checkMarkCorrect) {
        set_IC_NUM_SMALL_CHAR(checkMarkFalse);
        set_IC_NUM_CAPITAL_CHAR(checkMarkFalse);
        set_IC_NUM_SPECIAL_CHAR(checkMarkFalse);
        set_IC_ENFORCE_START_WITH_ALPHA(checkMarkFalse);
      //  set_ENFORCE_SPECIAL_CHAR(checkMarkFalse);
      }
    }
  }

  var hideLoader = "";
  if (visible) {
    hideLoader = "";
  } else {
    hideLoader = "hide-loader";
  }

  let leftLocalized = "left";
  let mr2Localized = "mr-2";

  if (i18next.language === "ar") {
    leftLocalized = "right";
    mr2Localized = "ml-2";
  }
  if (redirect) {
    return <Redirect to={redirect} />;
  }

  return (
    <div className="AuthCont ChangePasswordFirstLogIn">
      <form name="form" style={{display:"flex",flexDirection: 'column'}}>
        <div className="center">
          {/* <div className="form-group">
                        <input
                            className="input-textbox"
                            type="text"
                            name="email"
                            placeholder="User Name"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)} />
                    </div> */}
          {/* <div className="form-group">
                        <input
                            className="input-textbox"
                            type="password"
                            name="password"
                            placeholder="Old Password"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                        />
                    </div> */}
          {/* <div className="form-group">
                        <input
                            className="input-textbox"
                            type="password"
                            name="Oldpassword"
                            placeholder="Old Password"
                            value={oldPassword}
                            onChange={(e) => setoldPassword(e.target.value)}
                        />
                    </div> */}
          <div className="form-group container-input-with-password" style={{ display: "flex", justifyContent: "flex-end" }}>
            <input
              className="input-textbox"
              type={NewPasswordType}
              name="password"
              placeholder={t("enter_new_password")}
              value={password}
              onChange={(e) => {
                e.preventDefault();
                onChangeNewPassword(e);
              }}
               onKeyDown={(e) => {
                        const charCode = e.key.charCodeAt(0);
                        if (charCode >= 0x0600 && charCode <= 0x06ff) {
                          e.preventDefault();
                        }
                      }}
            />

            <i
              className={NewPasswordType === "password" ? "fa fa-eye-slash" : "fa fa-eye"}
              aria-hidden="true"
              style={{
                fontSize: "15px",
                cursor: "pointer",
                // right: i18next.language === "en" ? "250px" : "",
                // left: i18next.language === "en" ? "" : "250px",
                position: "absolute",
                top: "20px",
                color: "black",
              }}
              
              onClick={(e) => {
                e.preventDefault();
                if (NewPasswordType === "password") {
                  setNewPasswordType("text");
                } else {
                  setNewPasswordType("password");
                }
              }}></i>
          </div>
          <div className="form-group container-input-with-password" style={{ display: "flex", justifyContent: "flex-end" }}>
            <input className="input-textbox" type={ConfirmPasswordType} name="confirm password" 
            placeholder={t("enter_confirm_new_password")} value={confirmPassword} 
             onKeyDown={(e) => {
                        const charCode = e.key.charCodeAt(0);
                        if (charCode >= 0x0600 && charCode <= 0x06ff) {
                          e.preventDefault();
                        }
                      }}
            onChange={(e) => setConfirmPassword(e.target.value)} />
            <i
              className={ConfirmPasswordType === "password" ? "fa fa-eye-slash" : "fa fa-eye"}
              aria-hidden="true"
              style={{
                fontSize: "15px",
                cursor: "pointer",
                // right: i18next.language === "en" ? "250px" : "",
                // left: i18next.language === "en" ? "" : "250px",
                position: "absolute",
                top: "20px",
                color: "black",
              }}
              onClick={(e) => {
                e.preventDefault();
                if (ConfirmPasswordType === "password") {
                  setConfirmPasswordType("text");
                } else {
                  setConfirmPasswordType("password");
                }
              }}></i>
          </div>

          {localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT" ? (
            <>
              {/* <div className="pt-2" style={{ display: "flex" }}> */}
              {/* <div  style={{ width: "135px", minWidth: "100px", fontSize: "14px", paddingTop: "10px" }}>
                                    {t("password2")}
                                </div> */}
              <div className="form-group">
                <input
                  className="input-textbox"
                  type="password"
                  id="password2"
                  name="password2"
                  value={password2}
                  onChange={(e) => {
                    setPassword2(e.target.value);
                  }}
                  placeholder={t("password2")}
                />
                {/* showRequired
                                        ? <div style={{ color: Colors.redNumber }}>
                                            This field is required
                                            </div>
                                        : null */}

                {/* </div> */}
              </div>

              {/* <div className="pt-2" style={{ display: "flex" }}> */}
              {/* <div  style={{ width: "135px", minWidth: "100px", fontSize: "14px", paddingTop: "10px" }}>
                                    {t("conpassword2")}
                                </div> */}
              <div className="form-group">
                <input className="input-textbox" type="password" id="ConfirmPassword2" name="ConfirmPassword2" value={confirmPassword2} onChange={(e) => setConfirmPassword2(e.target.value)} placeholder={t("conpassword2")} />
              </div>
              {/* </div> */}
            </>
          ) : null}
        </div>

        <div className="mt-3 mb-3" style={{ float: leftLocalized, textAlign: leftLocalized }}>
          {MINLENGTH !== "" ? (
            <div>
              <img className={mr2Localized + " check-mark"} src={IC_MINLENGTH} alt="" />
              <span>{t("passwordtooshort") + " " + MINLENGTH}</span>
            </div>
          ) : null}
          {ENFORCE_START_WITH_ALPHA !== "" && ENFORCE_START_WITH_ALPHA === "Y" ? (
            <div className="mt-1">
              <img className={mr2Localized + " check-mark"} src={IC_ENFORCE_START_WITH_ALPHA} alt="" />
              <span>{t("passwordcantstartno")}</span>
            </div>
          ) : null}
          {ENFORCE_SPECIAL_CHAR !== "" && ENFORCE_SPECIAL_CHAR === "Y" ? (
            <div className="mt-1">
              <img className={mr2Localized + " check-mark"} src={IC_ENFORCE_SPECIAL_CHAR} alt="" />
              {localStorage.getItem(Constants.localStorageConstants.company_name) === "ALRAMZ" ? <span>{t("passwordEnforceSpecialCharALRAMZ")}</span> : <span>{t("passwordEnforceSpecialChar")}</span>}
            </div>
          ) : null}
          {NUM_SMALL_CHAR !== "" && parseInt(NUM_SMALL_CHAR) > 0 ? (
            <div className="mt-1">
              <img className={mr2Localized + " check-mark"} src={IC_NUM_SMALL_CHAR} alt="" />
              <span>{format(t("passwordcountsmallchar_X0"), NUM_SMALL_CHAR)}</span>
            </div>
          ) : null}
          {NUM_CAPITAL_CHAR !== "" && parseInt(NUM_CAPITAL_CHAR) > 0 ? (
            <div className="mt-1">
              <img className={mr2Localized + " check-mark"} src={IC_NUM_CAPITAL_CHAR} alt="" />
              <span>{format(t("passwordcountcapitalchar_X0"), NUM_CAPITAL_CHAR)}</span>
            </div>
          ) : null}
          {NUM_SPECIAL_CHAR !== "" && parseInt(NUM_SPECIAL_CHAR) > 0 && ENFORCE_SPECIAL_CHAR === "Y" ? (
            <div className="mt-1">
              <img className={mr2Localized + " check-mark"} src={IC_NUM_SPECIAL_CHAR} alt="" />
              <span>{format(t("passwordcountspecialchar_X0"), NUM_SPECIAL_CHAR)}</span>
            </div>
          ) : null}
          {Constants.config.CompanyName === "CIC" ? (
            <div className="mt-1">
              <img className={mr2Localized + " check-mark"} src={checkMarkFalse} alt="" />
              <span>{t("secondpasswordpolicy")}</span>
            </div>
          ) : null}
        </div>
        <div className="form-group center form-group-btns">
          <button className="auth-btns btn btn-primary customBtn" style={{ width: "50%" }} onClick={submit}>
            {t("ChangePasswordTitle")}
          </button>
        </div>
        <div>
          <button
            className={"link WelcomeMessageDiv"}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
            }}
            onClick={(event) => {
              event.preventDefault();
              // setRedirect(AppUrls.login);

              callLogOff();
              //  localStorage.getItem(Constants.localStorageConstants.company_name) === "CIBC" ? setRedirect(AppUrls.loginCIBC) :  setRedirect(AppUrls.login);
            }}>
            {t("cancelForgotPassword")}
          </button>
        </div>
      </form>
      {localStorage.getItem(Constants.localStorageConstants.company_name) !== "SIFS" ? (
        <div className={"center-loader loaderCss  " + hideLoader} style={{ backgroundColor: "#FFFFFFD9" }}>
          <Loader type="Bars" color="#00BFFF" height={100} width={100} visible={visible} />
        </div>
      ) : (
        <div className={" center-loader " + hideLoader} style={{ height: "100%", width: "100%" }}>
          <SpinnersLoadingSIP />
        </div>
      )}
    </div>
  );
}

export default ChangePassword;
